import { TaskTrainingStepConfig } from '@scale/shared/onboardingControlPanel/index';
import { OutlineSection } from 'react-scale/remotasks.com/components/Expert/OutlinePanel';
import { OutlineSectionV2 } from 'react-scale/remotasks.com/components/Expert/OutlinePanel/OutlineSectionV2';
import { useGetOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/stores/projectOutlineStore';
import { ProjectOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/types';
import { useUser } from 'react-scale/components/ui/UserContext';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';
import { useLogger } from 'react-scale/remotasks.com/components/Expert/utils';
import { OutlineSectionTitleAdornment } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/components/OutlineSectionTitleAdornment';

type TaskTrainingSectionProps = {
  node: TaskTrainingStepConfig;
};
export const TaskTrainingSection = ({ node }: TaskTrainingSectionProps) => {
  const user = useUser();
  const logger = useLogger();
  const useNewMpView = useUnleashFeatureFlag('mp-nav-change', { userId: user._id }, true);
  const isAgenticTaskTrainingEnabled = useUnleashFeatureFlag(
    'agentic-task-training',
    { userId: user._id },
    true,
  );
  const { status, selected } = useGetOutlineNodeStatus(node);

  logger.info('TaskTrainingSection: render check', {
    logger_name: 'task-training-section',
    practiceTaskId: node.practiceTaskId,
    practiceTaskTitle: node.practiceTaskTitle,
    isAgenticTaskTrainingEnabled,
    willRender: isAgenticTaskTrainingEnabled,
  });

  if (!isAgenticTaskTrainingEnabled) {
    return null;
  }

  return useNewMpView ? (
    <OutlineSectionV2
      title={node.practiceTaskTitle || 'Practice Task'}
      steps={[]}
      active={selected}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      titleEndAdornment={<OutlineSectionTitleAdornment status={status} />}
    />
  ) : (
    <OutlineSection
      title={node.practiceTaskTitle || 'Practice Task'}
      steps={[]}
      active={selected}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      titleEndAdornment={<OutlineSectionTitleAdornment status={status} />}
    />
  );
};
